<template>
  <div
    :class="{
      'electron-my-course': isElectron,
      'h5-my-course': isH5,
      'my-course': !isH5,
    }"
  >
    <div class="mobile-course-search">
      <CourseSearchInput
        v-model="keyword"
        :loading="searchSubmitting"
        :search-disabled="!canSubmitSearch"
        size="h5"
        @search="handleSearch"
        @clear="handleClearSearch"
      />
    </div>
    <ul
      v-if="courseList.length"
      v-loading="resultLoading"
      class="course-list-wrap"
    >
      <li
        class="my-course-crad"
        @click="showDetail(item.course_id)"
        v-for="(item, index) in courseList"
        :key="item.course_id + index"
      >
        <div class="cover">
          <img :src="processImageUrl(item.cover_url, 600)" alt="" />
        </div>
        <div class="course-info">
          <p class="name">
            {{ item.course_name }}
          </p>
          <div>
            <div class="lesson-num">
              <p>
                课时数：<span>{{ item.lesson_count }}课时</span>
              </p>
              <p
                class="white-btn"
                v-if="!item.is_comment && !isH5"
                @click.stop="goToEvaluate(item)"
              >
                去评价
              </p>
            </div>
            <p class="time">课程有效期： {{ dealValidityType(item) }}</p>
          </div>
        </div>
      </li>
    </ul>
    <el-empty
      v-else
      v-loading="resultLoading"
      description="暂无内容"
      :image="require('@/assets/img/live-list/empty.png')"
    ></el-empty>
  </div>
</template>

<script>
import { isH5, processImageUrl } from "@saas/components";
import moment from "moment";
import { getCourseList } from "@saas/service-api/src/learning-center";
import { getUnEvaluatedList } from "@saas/service-api/src/evaluate/index";
import CourseSearchInput from "./components/CourseSearchInput.vue";
import {
  buildCourseListParams,
  canSubmitCourseSearch,
  createDelayedLoadingController,
  normalizeCourseKeyword,
} from "./course-list-search";
export default {
  components: {
    CourseSearchInput,
  },
  data: function () {
    return {
      moment,
      courseList: [],
      keyword: "",
      activeKeyword: "",
      page_no: 1,
      page_size: 24,
      noMore: false, //没有更多
      loading: false, //加载数据中
      resultLoading: false,
      searchSubmitting: false,
      resultLoadingController: null,
      courseListRequestId: 0,
      isElectron: window.isElectron,
      isH5: isH5(),
    };
  },
  created() {
    this.resultLoadingController = createDelayedLoadingController({
      setLoading: (value) => {
        this.resultLoading = value;
      },
    });
    this.apiGetCourseList();
  },
  mounted() {
    this.$nextTick(() => {
      if (window.isElectron) {
        let elMain = document.getElementById("electron-main");
        if (!elMain) return;
        elMain.addEventListener("scroll", this.handleElScrollFn, true);
      } else {
        window.addEventListener("scroll", this.scrollFn, true); //监听页面滚动
      }
    });
  },
  beforeDestroy() {
    if (window.isElectron) {
      let elMain = document.getElementById("electron-main");
      if (!elMain) return;
      elMain.removeEventListener("scroll", this.handleElScrollFn, true);
    } else {
      window.removeEventListener("scroll", this.scrollFn, true); //销毁滚动事件
    }
    if (this.resultLoadingController) {
      this.resultLoadingController.cancel();
    }
  },
  computed: {
    canSubmitSearch() {
      return canSubmitCourseSearch({
        keyword: this.keyword,
        activeKeyword: this.activeKeyword,
      });
    },
  },
  methods: {
    processImageUrl,
    dealValidityType(item) {
      if (item.validity_type === 1) {
        return `至 ${moment(item.end_validity * 1000).format(
          "YYYY年MM月DD日"
        )}`;
      } else if (item.validity_type === 2) {
        if (isH5) {
          return `至${moment(item.end_validity * 1000).format(
            "YYYY年MM月DD日"
          )}`;
        } else {
          return `至${moment(item.end_validity * 1000).format(
            "YYYY年MM月DD日 HH:mm:ss"
          )}`;
        }
      } else {
        return "永久有效";
      }
    },
    apiGetCourseList() {
      const requestId = ++this.courseListRequestId;
      const shouldShowResultLoading = this.page_no === 1;
      this.loading = true;
      if (shouldShowResultLoading) {
        this.resultLoadingController.start();
      }
      let params = buildCourseListParams({
        page_no: this.page_no,
        page_size: this.page_size,
        keyword: this.activeKeyword,
      });
      return getCourseList(params)
        .then((res) => {
          if (requestId !== this.courseListRequestId) return;
          if (res.code === 1) {
            let arr = res.data?.list || [];
            if (params.page_no === 1) {
              this.courseList = arr;
            } else {
              this.courseList = this.courseList.concat(arr);
            }
            if (this.courseList.length === res.data.total) {
              this.noMore = true;
            } else {
              this.noMore = false;
            }
          } else {
            this.$message.error(res.message);
          }
        })
        .catch((err) => {
          if (requestId !== this.courseListRequestId) return;
          this.$message.error(err?.message || "加载失败");
        })
        .finally(() => {
          if (requestId !== this.courseListRequestId) return;
          this.loading = false;
          if (shouldShowResultLoading) {
            this.resultLoadingController.stop();
          }
        });
    },
    handleSearch() {
      if (this.searchSubmitting || !this.canSubmitSearch) return;
      this.activeKeyword = normalizeCourseKeyword(this.keyword);
      this.page_no = 1;
      this.noMore = false;
      this.searchSubmitting = true;
      this.apiGetCourseList().finally(() => {
        this.searchSubmitting = false;
      });
    },
    handleClearSearch() {
      if (this.searchSubmitting) return;
      if (!this.activeKeyword) return;
      this.activeKeyword = "";
      this.page_no = 1;
      this.noMore = false;
      this.searchSubmitting = true;
      this.apiGetCourseList().finally(() => {
        this.searchSubmitting = false;
      });
    },
    handleElScrollFn(event) {
      if (this.loading || this.noMore) return false;
      const { scrollTop, scrollHeight, clientHeight } = event.target;
      // 触底-加载下一页
      if (scrollTop + clientHeight >= scrollHeight - 100) {
        this.loading = true;
        this.page_no++;
        this.apiGetCourseList();
      }
    },
    scrollFn() {
      if (this.loading) return false;
      //获取网页的总高度
      var htmlHeight =
        document.body.scrollHeight || document.documentElement.scrollHeight;
      //clientHeight是网页在浏览器中的可视高度
      var clientHeight =
        document.body.clientHeight || document.documentElement.clientHeight;
      //scrollTop是浏览器滚动条的top位置
      var scrollTop =
        document.body.scrollTop || document.documentElement.scrollTop;
      //判断到底部了
      if (scrollTop + clientHeight > htmlHeight - 100) {
        if (!this.noMore) {
          this.loading = true;
          this.page_no++;
          this.apiGetCourseList();
        } else {
          window.removeEventListener("scroll", this.scrollFn, true); //销毁滚动事件
        }
      }
    },

    showDetail(id) {
      this.$router.push({ name: "myCourseDetail", params: { id } });
    },
    goToEvaluate(item) {
      // 1. 课程课时数为 0，给错误提示“课程中暂无课时，不能评价”
      // 2. 若已学习课时数为 0，给错误提示“至少学完一个课时才可以评价”
      getUnEvaluatedList({
        page_no: 1,
        page_size: 1,
        course_id: item.course_id,
      }).then((res) => {
        if (res.code === 1) {
          const courseInfo = res.data.list[0] || {};
          if (courseInfo.lesson_count < 1) {
            this.$message.error("课程中暂无课时，不能评价");
          } else if (courseInfo.learned_lesson_count < 1) {
            this.$message.error("至少学完一个课时才可以评价");
          } else {
            this.$router.push("/comment/" + item.course_id);
          }
        } else {
          this.$message.error(res.message);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.my-course {
  min-height: calc(100vh - 110px);
  .course-list-wrap {
    display: flex;
    flex-wrap: wrap;
  }
  .my-course-crad {
    margin: 0 30px 30px 0;
    &:nth-child(3n) {
      margin-right: 0;
    }
  }
  .my-course-crad {
    &:hover {
      transition: all 0.3s ease;
      transform: translateY(-5px);
      box-shadow: 0px 6px 16px 0px rgba(102, 116, 107, 0.1);
      .cover img {
        transform: scale(1.2) rotate(0.02deg);
      }
    }
    transition: all 0.3s ease;
    width: 330px;
    height: 322px;
    background: var(--card-bg);
    border-radius: 24px;
    cursor: pointer;
    padding: 16px;
    display: flex;
    flex-direction: column;
    .cover {
      width: 298px;
      height: 168px;
      border-radius: 16px;
      margin-bottom: 14px;
      overflow: hidden;
    }
    .cover img {
      object-fit: cover;
      width: 100%;
      height: 100%;
      transition: 0.3s ease-in-out;
      will-change: transform;
      transform: scale(1) rotate(0.02deg);
    }
    .course-info {
      flex: 1;
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .name {
        font-weight: 500;
        font-size: 18px;
        color: var(--text-primary);
        line-height: 28px;
        word-break: break-all;
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
      }
      .lesson-num {
        margin-bottom: 6px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .white-btn {
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          text-align: center;
          padding: 0 9px;
          height: 26px;
          line-height: 1;
          background: linear-gradient(132deg, #00eb81 0%, #00c89d 100%);
          border-radius: 13px;
          font-weight: 600;
          font-size: 14px;
          color: #ffffff;
        }
      }
      .lesson-num,
      .time {
        font-weight: 400;
        font-size: 14px;
        color: var(--text-secondary);
        line-height: 20px;
      }
    }
  }
  .el-empty {
    height: 400px;
    background: var(--card-bg);
    border-radius: 24px;
  }
}

// 客户端
.my-course.electron-my-course {
  .my-course-crad {
    margin: 0 15px 15px 0;
    &:nth-child(4n) {
      margin-right: 0;
    }
  }
  .my-course-crad {
    width: 260px;
    height: 263px;
    border-radius: 18px;
    padding: 10px;
    .cover {
      width: 240px;
      height: 135px;
      border-radius: 16px;
      margin-bottom: 12px;
    }
    .course-info {
      .name {
        font-size: 14px;
        line-height: 20px;
      }
      .lesson-num {
        margin-bottom: 6px;
        .white-btn {
          height: 22px;
          line-height: 1;
          border-radius: 10px;
          font-size: 12px;
        }
      }
      .lesson-num,
      .time {
        font-size: 12px;
        line-height: 17px;
      }
    }
  }
}

// h5
.h5-my-course {
  padding-top: 1.39rem;
  background: var(--page-bg);
  .mobile-course-search {
    width: 9.36rem;
    margin: 0 auto 0.32rem;
  }
  .course-list-wrap {
    display: block;
  }
  .my-course-crad {
    display: flex;
    flex-direction: row;
    align-items: center;
    align-items: center;
    width: 9.36rem;
    height: 2.61rem;
    background: var(--card-bg);
    border-radius: 0.32rem;
    margin: 0 auto 0.32rem;
    padding: 0 0.27rem;
    .cover {
      width: 3.2rem;
      height: 2.08rem;
      border-radius: 0.16rem;
      margin-right: 0.27rem;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .course-info {
      height: 2.08rem;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      flex: 1;
      width: 0;
      .name {
        font-weight: 500;
        font-size: 0.37rem;
        color: var(--text-primary);
        line-height: 0.53rem;
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        line-break: anywhere;
      }
      .lesson-num,
      .time {
        font-weight: 400;
        font-size: 0.32rem;
        color: var(--text-secondary);
        line-height: 0.45rem;
      }
      .lesson-num {
        margin-bottom: 0.11rem;
      }
    }
  }
}
</style>
